import { isNullable } from '@app/utils'

import permissionService from '@app/services/permissionService'

import type { UserDto } from '@app/api/routes/auth/dtos'
import type { SettingMenuItem } from '../types'
import type { LntDropdownMenu } from '@app/components/base/Dropdown/types'

export const adaptDropdownMenu = (settings: SettingMenuItem[], user?: UserDto): LntDropdownMenu => {
  if (isNullable(user)) return []

  const filteredSettings = settings.filter(settingItem => {
    const { requiredRoles, requiredPermissions } = settingItem

    return permissionService.checkAccess({
      userRoles: user.roles,
      requiredRoles,
      requiredPermissions
    })
  })

  return filteredSettings.map(({ requiredRoles, requiredPermissions, ...settingItem }) => settingItem)
}
